import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { BaseSwitcherItemWrapper, SwitcherStyled, TextSwitcherItem } from "@similarweb/ui-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon, blue, bluegrey, midnight } = colorsPalettes;

export const StyledSwitch = styled(FlexColumn)`
    justify-content: center;

    ${SwitcherStyled} {
        border: 1px solid ${carbon[50]};
        border-radius: 3px;
        display: flex;
    }

    ${BaseSwitcherItemWrapper} {
        position: relative;

        &:not(:last-child) {
            border-right: 1px solid ${carbon[50]};
        }

        &:first-child {
            ${TextSwitcherItem} {
                border-bottom-left-radius: 3px;
                border-top-left-radius: 3px;

                &::after {
                    border-bottom-left-radius: 3px;
                    border-top-left-radius: 3px;
                }
            }
        }

        &:last-child {
            ${TextSwitcherItem} {
                border-bottom-right-radius: 3px;
                border-top-right-radius: 3px;

                &::after {
                    border-bottom-right-radius: 3px;
                    border-top-right-radius: 3px;
                }
            }
        }
    }

    ${TextSwitcherItem} {
        ${setFontVariant("body2", midnight[200])};
        transition: none;
        width: auto;
        height: auto;
        cursor: pointer;
        padding: 10px 12px;

        &::after {
            background-color: transparent;
            border: 1px solid transparent;
            content: "";
            height: 100%;
            position: absolute;
            pointer-events: none;
            width: 100%;
        }

        &.selected {
            ${setFontVariant("subtitle2", blue[400])};
            background-color: ${bluegrey[100]};
            line-height: 20px;

            &:hover {
                cursor: pointer;
                background-color: ${bluegrey[100]};
            }
        }

        &:hover {
            background-color: ${carbon[25]};
        }
    }
`;
